import { render, staticRenderFns } from "./PbProxyNotifications.vue?vue&type=template&id=08f6e458&"
import script from "./PbProxyNotifications.vue?vue&type=script&lang=js&"
export * from "./PbProxyNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports